/* Agriwelt system wizard. Source: Shopify-Kit-Sync/wizard (build_theme.py). Do not edit here. */
/* System wizard drawings: side silhouettes of the four machine types (pneumatic and gravity), distributor
   heads and the top view of the drill with its cable network. Generic shapes only: no maker's outline or logo. */
(function (root) {
  "use strict";

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  /* ---------- side silhouettes, viewBox 0 0 360 130, driving to the left ---------- */
  // Designer's drawings (owner 26.10, Marketing/AGRIWELT - Все для сайта/system-wizard-mockup/agriwelt-side-silhouettes-v5):
  // one tractor for every machine, the one from the tow-between / tow-behind drawings.
  var TRACTOR_SIDE =
    '<g class="sil-tractor">' +
    '<path d="M7 58 Q7 51 15 51 L76 49 L76 90 L7 90 Z"/>' +
    '<path d="M70 30 Q70 23 79 23 L115 23 Q122 23 122 30 L123 90 L70 90 Z"/>' +
    '<path d="M118 62 L134 62 L134 90 L118 90 Z"/>' +
    '<rect class="sil-glass" x="10" y="58" width="5" height="24" rx="2.0"/>' +
    '<rect class="sil-glass" x="18" y="55" width="14" height="3" rx="1.0"/>' +
    '<rect class="sil-glass" x="36" y="60" width="24" height="3" rx="1.0"/>' +
    '<rect class="sil-glass" x="36" y="66" width="24" height="3" rx="1.0"/>' +
    '<rect x="59" y="8" width="4" height="43" rx="2.0"/>' +
    '<rect x="58" y="6" width="6" height="4" rx="1.3"/>' +
    '<path d="M66 25 Q66 16 78 16 L118 16 Q128 16 128 25 L128 28 L66 28 Z"/>' +
    '<rect class="sil-glass" x="76" y="19" width="44" height="2" rx="0.7"/>' +
    '<path class="sil-glass" d="M76 33 Q76 30 80 30 L112 30 Q116 30 116 34 L116 62 L76 62 Z"/>' +
    '<rect x="95" y="30" width="3" height="32" rx="2.0"/>' +
    '<circle cx="32" cy="96" r="24"/>' +
    '<circle class="sil-hub" cx="32" cy="96" r="14.9"/>' +
    '<circle cx="32" cy="96" r="11.0"/>' +
    '<circle class="sil-hub" cx="32" cy="96" r="3.4"/>' +
    '<circle cx="108" cy="96" r="24"/>' +
    '<circle class="sil-hub" cx="108" cy="96" r="14.9"/>' +
    '<circle cx="108" cy="96" r="11.0"/>' +
    '<circle class="sil-hub" cx="108" cy="96" r="3.4"/>' +
    '<rect x="126" y="92" width="14" height="5" rx="1.7"/>' +
    '</g>';

  var MACHINE_SIDE = {
    mounted:
      '<path class="sil-bar" d="M132 74 L150 70"/>' +
      '<path class="sil-bar" d="M136 96 L146 98"/>' +
      '<rect x="144" y="62" width="6" height="34" rx="2.0"/>' +
      '<path d="M144 98 Q144 94 148 94 L204 94 Q208 94 208 98 L208 108 L144 108 Z"/>' +
      '<rect class="sil-glass" x="146" y="90" width="60" height="4" rx="1.3"/>' +
      '<path class="sil-line" d="M150 108 L150 119"/>' +
      '<path class="sil-line" d="M158 108 L158 119"/>' +
      '<path class="sil-line" d="M166 108 L166 119"/>' +
      '<path class="sil-line" d="M174 108 L174 119"/>' +
      '<path class="sil-line" d="M182 108 L182 119"/>' +
      '<path class="sil-line" d="M190 108 L190 119"/>' +
      '<path class="sil-line" d="M198 108 L198 119"/>' +
      '<path class="sil-line" d="M206 108 L206 119"/>' +
      '<path class="sil-bar" d="M206 100 L218 104"/>' +
      '<circle cx="222" cy="107" r="13"/>' +
      '<circle class="sil-hub" cx="222" cy="107" r="9"/>' +
      '<path class="sil-line thin" d="M214 107 L230 107 M222 99 L222 115"/>' +
      '<circle cx="222" cy="107" r="3"/>' +
      '<path d="M152 34 Q152 28 158 28 L214 28 Q220 28 220 34 L214 74 L206 82 L166 82 L158 74 Z"/>' +
      '<rect x="148" y="23" width="76" height="5" rx="1.7"/>' +
      '<path class="sil-line thin" d="M150 23 L150 16 L222 16 L222 23"/>' +
      '<rect x="166" y="80" width="4" height="14" rx="2.0"/>' +
      '<rect x="204" y="80" width="4" height="14" rx="2.0"/>' +
      '<circle cx="158" cy="86" r="6"/>' +
      '<circle class="sil-hub" cx="158" cy="86" r="3"/>' +
      '<path class="sil-line" d="M208 80 Q228 86 236 72"/>' +
      '<rect x="234" y="46" width="4" height="30" rx="2.0"/>' +
      '<g class="sil-head">' +
      '<rect x="234" y="34" width="4" height="14" rx="2.0"/>' +
      '<path d="M225 36 Q236 22 247 36 Z"/>' +
      '</g>' +
      '<rect x="228" y="86" width="40" height="5" rx="1.7"/>' +
      '<path class="sil-line" d="M238 94 L244 112"/>' +
      '<circle cx="244" cy="112" r="6"/>' +
      '<circle class="sil-hub" cx="244" cy="112" r="2.1"/>' +
      '<path class="sil-line thin" d="M244 112 L252 115"/>' +
      '<circle cx="253" cy="115" r="4"/>' +
      '<circle class="sil-hub" cx="253" cy="115" r="1.4"/>' +
      '<path class="sil-line" d="M252 94 L258 112"/>' +
      '<circle cx="258" cy="112" r="6"/>' +
      '<circle class="sil-hub" cx="258" cy="112" r="2.1"/>' +
      '<path class="sil-line thin" d="M258 112 L266 115"/>' +
      '<circle cx="267" cy="115" r="4"/>' +
      '<circle class="sil-hub" cx="267" cy="115" r="1.4"/>' +
      '<path class="sil-hose" d="M236 40 C250 46 254 62 248 86 M236 40 C262 44 268 64 262 86"/>',
    trailed:
      '<path class="sil-bar" d="M136 95 L162 86"/>' +
      '<rect x="156" y="84" width="196" height="6" rx="2.0"/>' +
      '<circle cx="172" cy="106" r="11"/>' +
      '<circle class="sil-hub" cx="172" cy="106" r="3.8"/>' +
      '<circle cx="190" cy="106" r="11"/>' +
      '<circle class="sil-hub" cx="190" cy="106" r="3.8"/>' +
      '<circle cx="222" cy="104" r="16"/>' +
      '<circle class="sil-hub" cx="222" cy="104" r="9.9"/>' +
      '<circle cx="222" cy="104" r="7.4"/>' +
      '<circle class="sil-hub" cx="222" cy="104" r="2.2"/>' +
      '<circle cx="256" cy="104" r="16"/>' +
      '<circle class="sil-hub" cx="256" cy="104" r="9.9"/>' +
      '<circle cx="256" cy="104" r="7.4"/>' +
      '<circle class="sil-hub" cx="256" cy="104" r="2.2"/>' +
      '<path d="M176 34 Q176 26 184 26 L268 26 Q276 26 276 34 L268 72 L260 80 L196 80 L184 72 Z"/>' +
      '<rect x="172" y="21" width="108" height="5" rx="1.7"/>' +
      '<path class="sil-line thin" d="M174 21 L174 14 L278 14 L278 21"/>' +
      '<path class="sil-line thin" d="M170 30 L170 84 M170 44 L176 44 M170 58 L176 58 M170 72 L176 72"/>' +
      '<circle cx="164" cy="72" r="7"/>' +
      '<circle class="sil-hub" cx="164" cy="72" r="4"/>' +
      '<path class="sil-line" d="M262 78 Q284 86 292 72"/>' +
      '<rect x="290" y="46" width="4" height="38" rx="2.0"/>' +
      '<g class="sil-head">' +
      '<rect x="290" y="34" width="4" height="14" rx="2.0"/>' +
      '<path d="M281 36 Q292 22 303 36 Z"/>' +
      '</g>' +
      '<path class="sil-line" d="M290 90 L296 112"/>' +
      '<circle cx="296" cy="112" r="6"/>' +
      '<circle class="sil-hub" cx="296" cy="112" r="2.1"/>' +
      '<path class="sil-line thin" d="M296 112 L304 115"/>' +
      '<circle cx="305" cy="115" r="4"/>' +
      '<circle class="sil-hub" cx="305" cy="115" r="1.4"/>' +
      '<path class="sil-line" d="M310 90 L316 112"/>' +
      '<circle cx="316" cy="112" r="6"/>' +
      '<circle class="sil-hub" cx="316" cy="112" r="2.1"/>' +
      '<path class="sil-line thin" d="M316 112 L324 115"/>' +
      '<circle cx="325" cy="115" r="4"/>' +
      '<circle class="sil-hub" cx="325" cy="115" r="1.4"/>' +
      '<path class="sil-line thin" d="M334 90 L338 119"/>' +
      '<path class="sil-line thin" d="M339 90 L343 119"/>' +
      '<path class="sil-line thin" d="M344 90 L348 119"/>' +
      '<path class="sil-line thin" d="M349 90 L353 119"/>' +
      '<path class="sil-hose" d="M292 40 C304 46 306 64 292 88 M292 40 C320 44 322 64 312 88"/>',
    cartFront:
      '<path class="sil-bar" d="M138 95 L152 90"/>' +
      '<path d="M156 30 Q156 22 164 22 L230 22 Q238 22 238 30 L238 56 L222 76 L172 76 L156 56 Z"/>' +
      '<rect class="sil-glass" x="196" y="24" width="2" height="50" rx="2.0"/>' +
      '<path class="sil-line thin" d="M164 22 L164 14 L230 14 L230 22 M197 14 L197 22"/>' +
      '<path class="sil-line thin" d="M152 30 L152 80 M152 40 L156 40 M152 50 L156 50 M152 60 L156 60 M152 70 L156 70"/>' +
      '<rect x="174" y="76" width="46" height="6" rx="2.0"/>' +
      '<rect x="150" y="82" width="94" height="6" rx="2.0"/>' +
      '<circle cx="243" cy="66" r="8"/>' +
      '<circle class="sil-hub" cx="243" cy="66" r="5"/>' +
      '<circle cx="243" cy="66" r="2"/>' +
      '<circle cx="180" cy="102" r="18"/>' +
      '<circle class="sil-hub" cx="180" cy="102" r="11.2"/>' +
      '<circle cx="180" cy="102" r="8.3"/>' +
      '<circle class="sil-hub" cx="180" cy="102" r="2.5"/>' +
      '<circle cx="216" cy="102" r="18"/>' +
      '<circle class="sil-hub" cx="216" cy="102" r="11.2"/>' +
      '<circle cx="216" cy="102" r="8.3"/>' +
      '<circle class="sil-hub" cx="216" cy="102" r="2.5"/>' +
      '<path class="sil-bar" d="M244 92 L262 90"/>' +
      '<rect x="258" y="82" width="98" height="7" rx="2.0"/>' +
      '<path class="sil-line" d="M266 90 L266 102 Q266 118 261 119"/>' +
      '<circle cx="272" cy="115" r="5"/>' +
      '<circle class="sil-hub" cx="272" cy="115" r="1.8"/>' +
      '<path class="sil-line" d="M278 90 L278 102 Q278 118 273 119"/>' +
      '<circle cx="284" cy="115" r="5"/>' +
      '<circle class="sil-hub" cx="284" cy="115" r="1.8"/>' +
      '<path class="sil-line" d="M290 90 L290 102 Q290 118 285 119"/>' +
      '<circle cx="296" cy="115" r="5"/>' +
      '<circle class="sil-hub" cx="296" cy="115" r="1.8"/>' +
      '<path class="sil-line" d="M302 90 L302 102 Q302 118 297 119"/>' +
      '<circle cx="308" cy="115" r="5"/>' +
      '<circle class="sil-hub" cx="308" cy="115" r="1.8"/>' +
      '<path class="sil-line" d="M314 90 L314 102 Q314 118 309 119"/>' +
      '<circle cx="320" cy="115" r="5"/>' +
      '<circle class="sil-hub" cx="320" cy="115" r="1.8"/>' +
      '<path class="sil-line" d="M326 90 L326 102 Q326 118 321 119"/>' +
      '<circle cx="332" cy="115" r="5"/>' +
      '<circle class="sil-hub" cx="332" cy="115" r="1.8"/>' +
      '<path class="sil-line" d="M338 90 L338 102 Q338 118 333 119"/>' +
      '<circle cx="344" cy="115" r="5"/>' +
      '<circle class="sil-hub" cx="344" cy="115" r="1.8"/>' +
      '<path class="sil-line" d="M350 90 L350 102 Q350 118 345 119"/>' +
      '<circle cx="356" cy="115" r="5"/>' +
      '<circle class="sil-hub" cx="356" cy="115" r="1.8"/>' +
      '<rect x="282.5" y="70" width="3" height="12" rx="2.0"/>' +
      '<rect x="328.5" y="70" width="3" height="12" rx="2.0"/>' +
      '<g class="sil-head">' +
      '<rect x="282" y="58" width="4" height="14" rx="2.0"/>' +
      '<path d="M273 60 Q284 46 295 60 Z"/>' +
      '</g>' +
      '<g class="sil-head">' +
      '<rect x="328" y="58" width="4" height="14" rx="2.0"/>' +
      '<path d="M319 60 Q330 46 341 60 Z"/>' +
      '</g>' +
      '<path class="sil-line thin" d="M284 62 C276 70 270 76 268 84 M284 62 C292 70 298 76 300 84"/>' +
      '<path class="sil-line thin" d="M330 62 C322 70 316 76 314 84 M330 62 C338 70 344 76 346 84"/>' +
      '<path class="sil-hose" d="M246 64 C262 50 276 52 284 60 M246 68 C282 44 318 50 330 60"/>',
    cartRear:
      '<path class="sil-bar" d="M138 95 L152 90"/>' +
      '<rect x="148" y="82" width="108" height="7" rx="2.0"/>' +
      '<path class="sil-line" d="M156 90 L156 102 Q156 118 151 119"/>' +
      '<circle cx="162" cy="115" r="5"/>' +
      '<circle class="sil-hub" cx="162" cy="115" r="1.8"/>' +
      '<path class="sil-line" d="M168 90 L168 102 Q168 118 163 119"/>' +
      '<circle cx="174" cy="115" r="5"/>' +
      '<circle class="sil-hub" cx="174" cy="115" r="1.8"/>' +
      '<path class="sil-line" d="M180 90 L180 102 Q180 118 175 119"/>' +
      '<circle cx="186" cy="115" r="5"/>' +
      '<circle class="sil-hub" cx="186" cy="115" r="1.8"/>' +
      '<path class="sil-line" d="M192 90 L192 102 Q192 118 187 119"/>' +
      '<circle cx="198" cy="115" r="5"/>' +
      '<circle class="sil-hub" cx="198" cy="115" r="1.8"/>' +
      '<path class="sil-line" d="M204 90 L204 102 Q204 118 199 119"/>' +
      '<circle cx="210" cy="115" r="5"/>' +
      '<circle class="sil-hub" cx="210" cy="115" r="1.8"/>' +
      '<path class="sil-line" d="M216 90 L216 102 Q216 118 211 119"/>' +
      '<circle cx="222" cy="115" r="5"/>' +
      '<circle class="sil-hub" cx="222" cy="115" r="1.8"/>' +
      '<path class="sil-line" d="M228 90 L228 102 Q228 118 223 119"/>' +
      '<circle cx="234" cy="115" r="5"/>' +
      '<circle class="sil-hub" cx="234" cy="115" r="1.8"/>' +
      '<path class="sil-line" d="M240 90 L240 102 Q240 118 235 119"/>' +
      '<circle cx="246" cy="115" r="5"/>' +
      '<circle class="sil-hub" cx="246" cy="115" r="1.8"/>' +
      '<rect x="176.5" y="70" width="3" height="12" rx="2.0"/>' +
      '<rect x="224.5" y="70" width="3" height="12" rx="2.0"/>' +
      '<g class="sil-head">' +
      '<rect x="176" y="58" width="4" height="14" rx="2.0"/>' +
      '<path d="M167 60 Q178 46 189 60 Z"/>' +
      '</g>' +
      '<g class="sil-head">' +
      '<rect x="224" y="58" width="4" height="14" rx="2.0"/>' +
      '<path d="M215 60 Q226 46 237 60 Z"/>' +
      '</g>' +
      '<path class="sil-line thin" d="M178 62 C170 70 164 76 162 84 M178 62 C186 70 192 76 194 84"/>' +
      '<path class="sil-line thin" d="M226 62 C218 70 212 76 210 84 M226 62 C234 70 240 76 242 84"/>' +
      '<path class="sil-bar" d="M254 92 L264 90"/>' +
      '<path d="M268 30 Q268 22 276 22 L342 22 Q350 22 350 30 L350 56 L334 76 L284 76 L268 56 Z"/>' +
      '<rect class="sil-glass" x="308" y="24" width="2" height="50" rx="2.0"/>' +
      '<path class="sil-line thin" d="M276 22 L276 14 L342 14 L342 22 M309 14 L309 22"/>' +
      '<path class="sil-line thin" d="M264 30 L264 80 M264 40 L268 40 M264 50 L268 50 M264 60 L268 60 M264 70 L268 70"/>' +
      '<rect x="286" y="76" width="46" height="6" rx="2.0"/>' +
      '<rect x="262" y="82" width="94" height="6" rx="2.0"/>' +
      '<circle cx="282" cy="90" r="7"/>' +
      '<circle class="sil-hub" cx="282" cy="90" r="4"/>' +
      '<circle cx="282" cy="90" r="1.6"/>' +
      '<circle cx="292" cy="102" r="18"/>' +
      '<circle class="sil-hub" cx="292" cy="102" r="11.2"/>' +
      '<circle cx="292" cy="102" r="8.3"/>' +
      '<circle class="sil-hub" cx="292" cy="102" r="2.5"/>' +
      '<circle cx="328" cy="102" r="18"/>' +
      '<circle class="sil-hub" cx="328" cy="102" r="11.2"/>' +
      '<circle cx="328" cy="102" r="8.3"/>' +
      '<circle class="sil-hub" cx="328" cy="102" r="2.5"/>' +
      '<path class="sil-hose" d="M276 86 C262 50 236 50 226 60 M276 86 C252 36 192 46 178 60"/>'
  };

  // Box drills (gravity, no heads): a long hopper over the whole width, a tube per row.
  var GRAVITY_SIDE = {
    mounted:
      '<path class="sil-bar" d="M132 74 L150 70"/>' +
      '<path class="sil-bar" d="M136 96 L146 98"/>' +
      '<rect x="144" y="62" width="6" height="34" rx="2.0"/>' +
      '<path d="M144 98 Q144 94 148 94 L204 94 Q208 94 208 98 L208 108 L144 108 Z"/>' +
      '<rect class="sil-glass" x="146" y="90" width="60" height="4" rx="1.3"/>' +
      '<path class="sil-line" d="M150 108 L150 119"/>' +
      '<path class="sil-line" d="M158 108 L158 119"/>' +
      '<path class="sil-line" d="M166 108 L166 119"/>' +
      '<path class="sil-line" d="M174 108 L174 119"/>' +
      '<path class="sil-line" d="M182 108 L182 119"/>' +
      '<path class="sil-line" d="M190 108 L190 119"/>' +
      '<path class="sil-line" d="M198 108 L198 119"/>' +
      '<path class="sil-line" d="M206 108 L206 119"/>' +
      '<path class="sil-bar" d="M206 100 L218 104"/>' +
      '<circle cx="222" cy="107" r="13"/>' +
      '<circle class="sil-hub" cx="222" cy="107" r="9"/>' +
      '<path class="sil-line thin" d="M214 107 L230 107 M222 99 L222 115"/>' +
      '<circle cx="222" cy="107" r="3"/>' +
      '<rect x="158" y="70" width="4" height="24" rx="2.0"/>' +
      '<rect x="212" y="70" width="4" height="24" rx="2.0"/>' +
      '<path d="M150 32 L224 32 L218 64 L156 64 Z"/>' +
      '<rect x="146" y="26" width="82" height="6" rx="2.0"/>' +
      '<rect x="152" y="64" width="68" height="6" rx="2.0"/>' +
      '<path class="sil-line thin" d="M156 70 L232 104"/>' +
      '<path class="sil-line thin" d="M164 70 L236 104"/>' +
      '<path class="sil-line thin" d="M172 70 L240 104"/>' +
      '<path class="sil-line thin" d="M180 70 L244 104"/>' +
      '<path class="sil-line thin" d="M188 70 L248 104"/>' +
      '<path class="sil-line thin" d="M196 70 L252 104"/>' +
      '<path class="sil-line thin" d="M204 70 L256 104"/>' +
      '<path class="sil-line thin" d="M212 70 L260 104"/>' +
      '<rect x="226" y="96" width="40" height="5" rx="1.7"/>' +
      '<path class="sil-line" d="M234 101 L232 116"/>' +
      '<circle cx="232" cy="114" r="4"/>' +
      '<circle class="sil-hub" cx="232" cy="114" r="1.4"/>' +
      '<path class="sil-line" d="M242 101 L240 116"/>' +
      '<circle cx="240" cy="114" r="4"/>' +
      '<circle class="sil-hub" cx="240" cy="114" r="1.4"/>' +
      '<path class="sil-line" d="M250 101 L248 116"/>' +
      '<circle cx="248" cy="114" r="4"/>' +
      '<circle class="sil-hub" cx="248" cy="114" r="1.4"/>' +
      '<path class="sil-line" d="M258 101 L256 116"/>' +
      '<circle cx="256" cy="114" r="4"/>' +
      '<circle class="sil-hub" cx="256" cy="114" r="1.4"/>' +
      '<path class="sil-line thin" d="M258 101 L262 119"/>' +
      '<path class="sil-line thin" d="M261 101 L265 119"/>' +
      '<path class="sil-line thin" d="M264 101 L268 119"/>',
    trailed:
      '<path class="sil-bar" d="M136 95 L178 84"/>' +
      '<rect x="172" y="80" width="160" height="6" rx="2.0"/>' +
      '<path d="M178 30 L330 30 L324 64 L184 64 Z"/>' +
      '<rect x="174" y="24" width="160" height="6" rx="2.0"/>' +
      '<rect x="184" y="64" width="140" height="5" rx="1.7"/>' +
      '<path class="sil-line thin" d="M176 24 L176 16 L332 16 L332 24"/>' +
      '<path class="sil-line thin" d="M190 69 L194 108"/>' +
      '<path class="sil-line" d="M194 108 L192 119"/>' +
      '<path class="sil-line thin" d="M199 69 L203 108"/>' +
      '<path class="sil-line" d="M203 108 L201 119"/>' +
      '<path class="sil-line thin" d="M208 69 L212 108"/>' +
      '<path class="sil-line" d="M212 108 L210 119"/>' +
      '<path class="sil-line thin" d="M217 69 L221 108"/>' +
      '<path class="sil-line" d="M221 108 L219 119"/>' +
      '<path class="sil-line thin" d="M226 69 L230 108"/>' +
      '<path class="sil-line" d="M230 108 L228 119"/>' +
      '<path class="sil-line thin" d="M235 69 L239 108"/>' +
      '<path class="sil-line" d="M239 108 L237 119"/>' +
      '<path class="sil-line thin" d="M244 69 L248 108"/>' +
      '<path class="sil-line" d="M248 108 L246 119"/>' +
      '<path class="sil-line thin" d="M253 69 L257 108"/>' +
      '<path class="sil-line" d="M257 108 L255 119"/>' +
      '<path class="sil-line thin" d="M262 69 L266 108"/>' +
      '<path class="sil-line" d="M266 108 L264 119"/>' +
      '<path class="sil-line thin" d="M271 69 L275 108"/>' +
      '<path class="sil-line" d="M275 108 L273 119"/>' +
      '<path class="sil-line thin" d="M280 69 L284 108"/>' +
      '<path class="sil-line" d="M284 108 L282 119"/>' +
      '<path class="sil-line thin" d="M289 69 L293 108"/>' +
      '<path class="sil-line" d="M293 108 L291 119"/>' +
      '<path class="sil-line thin" d="M298 69 L302 108"/>' +
      '<path class="sil-line" d="M302 108 L300 119"/>' +
      '<path class="sil-line thin" d="M307 69 L311 108"/>' +
      '<path class="sil-line" d="M311 108 L309 119"/>' +
      '<path class="sil-line thin" d="M316 69 L320 108"/>' +
      '<path class="sil-line" d="M320 108 L318 119"/>' +
      '<circle cx="256" cy="100" r="19"/>' +
      '<circle class="sil-hub" cx="256" cy="100" r="11.8"/>' +
      '<circle cx="256" cy="100" r="8.7"/>' +
      '<circle class="sil-hub" cx="256" cy="100" r="2.7"/>' +
      '<path class="sil-line thin" d="M332 86 L336 119"/>' +
      '<path class="sil-line thin" d="M337 86 L341 119"/>' +
      '<path class="sil-line thin" d="M342 86 L346 119"/>' +
      '<path class="sil-line thin" d="M347 86 L351 119"/>'
  };

  function silhouette(type, gravity) {
    var body = gravity && GRAVITY_SIDE[type] ? GRAVITY_SIDE[type] : MACHINE_SIDE[type];
    return '<svg class="sil" viewBox="0 0 360 130" role="img" aria-hidden="true">' +
      '<path class="sil-ground" d="M4 121 L356 121"/>' + TRACTOR_SIDE + '<g class="sil-machine">' + body + '</g></svg>';
  }

  /* ---------- a distributor head seen from above: hub and hoses ---------- */
  function head(cx, cy, r, outlets, closed, cls) {
    var s = '<g class="head ' + (cls || "") + '">';
    for (var i = 0; i < outlets; i++) {
      var a = -Math.PI / 2 + (2 * Math.PI * i) / outlets;
      var x1 = cx + Math.cos(a) * r * 0.42, y1 = cy + Math.sin(a) * r * 0.42;
      var x2 = cx + Math.cos(a) * r, y2 = cy + Math.sin(a) * r;
      var off = closed.indexOf(i) >= 0;
      s += '<path class="spoke' + (off ? " off" : "") + '" d="M' + x1.toFixed(1) + " " + y1.toFixed(1) + " L" + x2.toFixed(1) + " " + y2.toFixed(1) + '"/>';
    }
    s += '<circle class="hub" cx="' + cx + '" cy="' + cy + '" r="' + (r * 0.42).toFixed(1) + '"/></g>';
    return s;
  }

  /* Big head for the editor: every outlet is a button. */
  function headEditor(h, kind, label) {
    var n = h.o, R = 92, cx = 120, cy = 120;
    var rr = Math.max(6, Math.min(14, (Math.PI * R / n) * 0.78));
    var s = '<svg class="head-editor ' + kind + '" viewBox="0 0 240 240" role="group" aria-label="' + esc(label) + '">';
    for (var i = 0; i < n; i++) {
      var a = -Math.PI / 2 + (2 * Math.PI * i) / n;
      var x = cx + Math.cos(a) * R, y = cy + Math.sin(a) * R;
      var off = h.c.indexOf(i) >= 0;
      s += '<path class="spoke' + (off ? " off" : "") + '" d="M' + (cx + Math.cos(a) * 36).toFixed(1) + " " + (cy + Math.sin(a) * 36).toFixed(1) +
        " L" + (x - Math.cos(a) * rr).toFixed(1) + " " + (y - Math.sin(a) * rr).toFixed(1) + '"/>';
      s += '<g class="outlet' + (off ? " off" : "") + '" data-outlet="' + i + '" role="button" tabindex="0" aria-pressed="' + off + '" aria-label="' + (i + 1) + '">' +
        '<circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' + (rr + 6).toFixed(1) + '" class="hit"/>' +
        '<circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' + rr.toFixed(1) + '" class="cap"/>' +
        (off ? '<path class="cross" d="M' + (x - rr * 0.5).toFixed(1) + " " + (y - rr * 0.5).toFixed(1) + " L" + (x + rr * 0.5).toFixed(1) + " " + (y + rr * 0.5).toFixed(1) +
          " M" + (x + rr * 0.5).toFixed(1) + " " + (y - rr * 0.5).toFixed(1) + " L" + (x - rr * 0.5).toFixed(1) + " " + (y + rr * 0.5).toFixed(1) + '"/>' : "") +
        "</g>";
    }
    s += '<circle class="hub" cx="120" cy="120" r="34"/><text class="hub-n" x="120" y="128" text-anchor="middle">' + (n - h.c.length) + "</text></svg>";
    return s;
  }

  /* ---------- top view of the whole machine with the bus ----------
     Every cable of the kit is its own path with its own SKU, so a line of the part list lights exactly
     the pieces it stands for. Lines without a cable of their own (a plug straight into a head or a sensor)
     are drawn thin and never light. */
  function build(cfg, res, opt, GAP, pass1) {
    var L = opt.L, sku = opt.sku, W = 1000, out = [];
    var layout = res.layout;
    var seedGravity = !!cfg.seedGravity, fertGravity = !!cfg.fertGravity;
    var seed = cfg.seedHeads, fert = cfg.fert === "separate" ? cfg.fertHeads : [];
    var n = seed.length, fn = fert.length;
    var fw = Math.max(380, Math.min(920, Math.max(res.seedRows, res.fertRows) * 15));
    var fx0 = W / 2 - fw / 2, tx = 500;

    function pt(p) { return p[0].toFixed(1) + " " + p[1].toFixed(1); }
    function txt(x, y, s, cls, anchor) {
      return '<text x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" class="' + (cls || "lbl") + '" text-anchor="' + (anchor || "middle") + '">' + esc(s) + "</text>";
    }
    function path(pts, cls, skuOf) {
      return '<path class="' + cls + '"' + (skuOf ? ' data-sku="' + skuOf + '"' : "") + ' d="M' + pts.map(pt).join(" L") + '"/>';
    }
    var drawnCables = 0, nextX = 10, hitches = [], termAt = null, tailHitch = false;
    /* A coupling between two machines (owner 28.10): the socket (open arrow) on the side that feeds the bus, the
       plug (closed arrow) of the next machine pointing into it; it sits in the gap, on neither machine. */
    function hitchMark(x, y, live) {
      return '<g class="hitch' + (live ? "" : " idle") + '"><rect class="knock" x="' + (x - 14) + '" y="' + (y - 14) + '" width="28" height="28"/>' +
        '<path class="sock" d="M' + (x - 9) + " " + (y + 1) + " L" + x + " " + (y - 9) + " L" + (x + 9) + " " + (y + 1) + '"/>' +
        '<path class="plug" d="M' + (x - 9) + " " + (y + 12) + " L" + (x + 9) + " " + (y + 12) + " L" + x + " " + (y - 3) + ' Z"/></g>' +
        // a coupling the bus crosses is X10, X11 ... from the display outward; the one with no cable has no number
        (live ? (hitches.push([x, y, "X" + nextX]), txt(x + 22, y + 6, "X" + nextX++ + "  " + L.plan_hitch, "lbl dim note", "start"))
          : txt(x + 22, y + 6, L.plan_hitch_idle, "lbl dim note", "start"));
    }
    // a drawbar seen from above: two side beams meeting at the hitch, one beam down the middle
    function beams(y0, y1, w0, w1) {
      return '<path class="beam" d="M' + (tx - w1) + " " + y1 + " L" + (tx - w0) + " " + y0 + " L" + (tx + w0) + " " + y0 + " L" + (tx + w1) + " " + y1 +
        " M" + tx + " " + y0 + " L" + tx + " " + y1 + '"/>';
    }
    /* Cables are kept in place in `out` as objects and written out at the end: first their ends move onto the sensors,
       then they get their numbers (W1 is the power cable, then the bus from the display outward, owner 29.10). */
    var wires = [], links = [], ports = [], heads = [];
    function cable(pts, skuOf) { var w = { pts: pts.slice(), sku: skuOf, cls: "cable" }; wires.push(w); out.push(w); drawnCables++; }
    function link(pts) { var w = { pts: pts.slice(), sku: "", cls: "link" }; links.push(w); out.push(w); }
    function term(x, y, key, title) {
      termAt = [x, y];
      out.push('<g class="term" data-sku="' + sku[key] + '">' + (title ? "<title>" + esc(title) + "</title>" : "") +
        '<rect x="' + (x - 9) + '" y="' + (y - 9) + '" width="18" height="18"/>' + txt(x, y + 5, "T", "term-t") + txt(x + 14, y - 8, "X9", "lbl des", "start") +
        // the ESD terminator carries a ground lug to the frame: earth sign under the box (owner 22.10)
        (key === "term_esd" ? '<path class="gnd" d="M' + x + " " + (y + 9) + " L" + x + " " + (y + 15) + " M" + (x - 7) + " " + (y + 15) + " L" + (x + 7) + " " + (y + 15) +
          " M" + (x - 4.5) + " " + (y + 19) + " L" + (x + 4.5) + " " + (y + 19) + " M" + (x - 2) + " " + (y + 23) + " L" + (x + 2) + " " + (y + 23) + '"/>' : "") + "</g>");
    }
    /* HUB-8 of the 3-pin layer (owner 29-31.10): a small copy of its connection diagram — the box on the bus, a lead per used
       input with the sign of its sensor. The hub, its harnesses and plugs light the box; a sensor's own parts (sensor, extension,
       bracket, star wheel) light its leads. A tap opens the full diagram. */
    var hubsAt = [];
    function hubMark(x, y, level) {
      var sens = res.sensors, out2 = [];
      var own = function (kind) { return sens.parts.filter(function (q) { return q.why === kind && q.sku; }).map(function (q) { return q.sku; }).join(" "); };
      var hubSkus = sens.parts.filter(function (q) { return q.why === "hub" && q.sku; }).map(function (q) { return q.sku; }).join(" ");
      for (var h = 0; h < sens.hubs; h++) {
        var hx = x + h * 74, mine = sens.ports.filter(function (q) { return q.hub === h + 1; }), n = mine.length;
        // inputs 1-4 lead out to the right, 5-8 to the left (the two harnesses): the box stays low enough for the cable tags
        var bh = Math.max(26, Math.min(n, 4) * 7 + 8), top = y - bh / 2;
        if (level) {
          var bw2 = bh, lx0 = hx - bw2 / 2;
          if (h) out2.push('<path class="link" d="M' + (hx - 74 + bw2 / 2) + " " + y + " L" + lx0 + " " + y + '"/>');
          out2.push('<g class="hub8" data-sku="' + ("k-hub " + hubSkus).trim() + '"><rect class="hit" x="' + (lx0 - 14) + '" y="' + (y - 41) + '" width="' + (bw2 + 28) + '" height="82"/>' +
            '<rect x="' + lx0 + '" y="' + (y - 12) + '" width="' + bw2 + '" height="24" rx="3"/></g>');
          mine.forEach(function (q, i) {
            var side = i < 4 ? -1 : 1, row = i % 4, nRow = side < 0 ? Math.min(n, 4) : n - 4, lx = hx - ((nRow - 1) * 7) / 2 + row * 7;
            out2.push('<g class="hubport" data-sku="k-' + q.kind + " " + own(q.kind) + '"><path class="lead" d="M' + lx + " " + (y + side * 12) + " L" + lx + " " + (y + side * 28) + '"/>' +
              kindGlyph(q.kind, lx, y + side * 33, 3.2) + "</g>");
          });
          out2.push(txt(hx + bw2 / 2 + 4, y - 16, "A" + (h + 2), "lbl des", "start"));
          hubsAt.push([hx, y, 80, bw2 + 8]);
          continue;
        }
        if (h) out2.push('<path class="link" d="M' + (hx - 30) + " " + y + " L" + (hx - 12) + " " + y + '"/>');   // hubs chained by their own tails
        // a finger-sized invisible target around the box: the full diagram opens on a tap (owner 31.10)
        out2.push('<g class="hub8" data-sku="' + ("k-hub " + hubSkus).trim() + '"><rect class="hit" x="' + (hx - 30) + '" y="' + (top - 14) + '" width="82" height="' + (bh + 28) + '"/>' +
          '<rect x="' + (hx - 12) + '" y="' + top + '" width="24" height="' + bh + '" rx="3"/></g>');
        mine.forEach(function (q, i) {
          var side = i < 4 ? 1 : -1, row = i % 4, nRow = side > 0 ? Math.min(n, 4) : n - 4, ly = y - ((nRow - 1) * 7) / 2 + row * 7;
          out2.push('<g class="hubport" data-sku="k-' + q.kind + " " + own(q.kind) + '"><path class="lead" d="M' + (hx + side * 12) + " " + ly + " L" + (hx + side * 28) + " " + ly + '"/>' +
            kindGlyph(q.kind, hx + side * 33, ly, 3.2) + "</g>");
        });
        out2.push(txt(hx + 14, top - 4, "A" + (h + 2), "lbl des", "start"));   // off the bus line, where the cable tags go
        hubsAt.push([hx, y, bh, 76]);
      }
      out.push(out2.join(""));
    }
    // Cut a polyline into consecutive pieces proportional to `lens`.
    function cut(pts, lens) {
      var cum = [0];
      for (var i = 1; i < pts.length; i++) cum.push(cum[i - 1] + Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]));
      var total = cum[cum.length - 1], sum = lens.reduce(function (a, b) { return a + b; }, 0);
      function at(d) {
        for (var k = 1; k < pts.length; k++) if (cum[k] >= d) {
          var f = cum[k] === cum[k - 1] ? 0 : (d - cum[k - 1]) / (cum[k] - cum[k - 1]);
          return [pts[k - 1][0] + (pts[k][0] - pts[k - 1][0]) * f, pts[k - 1][1] + (pts[k][1] - pts[k - 1][1]) * f];
        }
        return pts[pts.length - 1];
      }
      var pieces = [], from = 0;
      lens.forEach(function (len) {
        var to = from + (total * len) / sum, pc = [at(from)];
        for (var k = 1; k < pts.length - 1; k++) if (cum[k] > from && cum[k] < to) pc.push(pts[k]);
        pc.push(at(to)); pieces.push(pc); from = to;
      });
      return pieces;
    }

    /* tractor seen from above, nose up; display in the cab, power plug at the rear socket */
    out.push('<g class="tractor">' +
      '<rect class="body" x="' + (tx - 28) + '" y="18" width="56" height="118" rx="6"/>' +
      '<rect class="tyre" x="' + (tx - 52) + '" y="26" width="16" height="36"/><rect class="tyre" x="' + (tx + 36) + '" y="26" width="16" height="36"/>' +
      '<rect class="tyre" x="' + (tx - 62) + '" y="88" width="24" height="56"/><rect class="tyre" x="' + (tx + 38) + '" y="88" width="24" height="56"/>' +
      '<rect class="cab" x="' + (tx - 36) + '" y="74" width="72" height="62" rx="4"/></g>');
    out.push('<rect class="disp" data-sku="' + (sku.display + " " + (sku.iso || "")).trim() + '" x="' + (tx - 18) + '" y="82" width="36" height="22" rx="2"/>');
    out.push(txt(tx + 44, 98, "A1", "lbl des", "start"));
    out.push(path([[tx + 18, 93], [tx + 28, 93], [tx + 28, 146]], "power", sku.power));
    out.push('<circle class="socket" cx="' + (tx + 28) + '" cy="149" r="5"/>');
    out.push(txt(tx - 72, 98, L.plan_cab, "lbl", "end"));
    out.push(txt(tx + 72, 152, L.plan_power, "lbl dim", "start"));

    /* Machines seen from above (owner 27-28.10): pale outlines, the cables bright. Each machine is a plain frame with
       its drawbar of beams; a coupling sits in the gap under the hitch. The cart is long and narrow (about 4 x 7 m). */
    var hitchY = 172, CART = { hw: 104, len: 330, db: 46 };
    var cartRearY = hitchY + 14 + CART.db + CART.len + 14;              // tow-between: its rear hitch to the drill
    var dTip = (layout === "B" ? cartRearY : hitchY) + 14, dTop = dTip + (cfg.machine === "mounted" ? 26 : 64);

    var hr = Math.max(14, Math.min(30, (fw / Math.max(n || 1, fn || 1)) * 0.36));
    /* Sensors sit on the hoses 20-30 cm from the head and chain to each other with 35 cm tails (owner 26.10): a ring
       around the head, one sensor on each outlet. The ring grows with the outlets so the dots never merge; a big head
       flattens it to an oval, so it stays between the cables above and the coulter bar below, and inside the head's
       share of the width. */
    function ring(outlets, share) {
      var need = (outlets * 13) / (2 * Math.PI), r0 = Math.max(hr + 12, need), ry = Math.min(r0, 56);
      var rx = r0 > ry ? Math.sqrt(Math.max(2 * need * need - ry * ry, ry * ry)) : r0;
      rx = Math.min(rx, share * 0.47); ry = Math.min(ry, rx);
      var per = 2 * Math.PI * Math.sqrt((rx * rx + ry * ry) / 2);
      return { rx: rx, ry: ry, dot: Math.max(3, Math.min(5.5, (per / outlets) * 0.4)) };
    }
    var ringTop = seedGravity ? 0 : Math.max.apply(null, seed.map(function (h) { return ring(h.outlets, fw / n).ry; }));
    var busGap = res.branched ? 74 : ringTop + 16;
    var frameY = dTop + (res.branched ? 164 : seedGravity ? 62 : 48 + busGap);   // a figure-eight needs its splitter over the frame, box drill or not
    var busY = frameY - busGap, sy = busY - 38;
    /* A row of heads with their hoses, or (gravity drill) a fence of tubes under one long hopper.
       Returns the points where the bus plugs in: one per head, or the two ends of the fence. */
    function machineRow(list, gravity, rows, y, barY, cls, sensorSku) {
      var att = [], dot = function (p, r) {
        return '<circle class="sensor ' + cls + '"' + (sensorSku ? ' data-sku="' + sensorSku + '"' : "") + ' cx="' + p[0].toFixed(1) + '" cy="' + p[1].toFixed(1) + '" r="' + r.toFixed(1) + '"/>';
      };
      if (gravity) {
        // a box drill: the sensors sit at the top of the tubes, just under the box (owner 26.10)
        var sy0 = y + 9;
        out.push('<rect class="hopper ' + cls + '" x="' + (fx0 - 8) + '" y="' + (y - 22) + '" width="' + (fw + 16) + '" height="22" rx="3"/>');
        for (var k = 0; k < rows; k++) {
          var px = fx0 + (fw * (k + 0.5)) / rows;
          out.push('<path class="hose ' + cls + '" d="M' + px.toFixed(1) + " " + y + " L" + px.toFixed(1) + " " + (barY - 7) + '"/>');
          out.push(dot([px, sy0], 5.5));
          att.push([px, sy0]);
        }
        out.push('<path class="chain ' + cls + '" d="M' + att[0][0].toFixed(1) + " " + sy0 + " L" + att[att.length - 1][0].toFixed(1) + " " + sy0 + '"/>');
      } else {
        list.forEach(function (h, i) {
          var m = list.length, s0 = fx0 + (fw * i) / m, s1 = fx0 + (fw * (i + 1)) / m, cx = fx0 + (fw * (i + 0.5)) / m;
          var no = h.outlets, rg = ring(no, s1 - s0), pos = [], q;
          // each sensor on its own spoke, the first at the top, as the head is drawn
          for (q = 0; q < no; q++) {
            var a = -Math.PI / 2 + (2 * Math.PI * q) / no;
            pos.push([cx + Math.cos(a) * rg.rx, y + Math.sin(a) * rg.ry]);
          }
          // the rows are dealt to the sensors from left to right, so the hoses barely cross
          var rank = pos.map(function (p, j) { return j; }).sort(function (u, v) { return pos[u][0] - pos[v][0] || pos[u][1] - pos[v][1]; });
          var chain = [], key = cx.toFixed(0) + "," + y.toFixed(0), k0 = GAP[key] || 0;
          for (var qq = 0; qq < no; qq++) {
            q = (qq + k0) % no;
            var hx = s0 + ((s1 - s0) * (rank.indexOf(q) + 0.5)) / no, off = h.closed.indexOf(q) >= 0, p = pos[q];
            out.push('<path class="hose ' + cls + (off ? " off" : "") + '" d="M' + cx.toFixed(1) + " " + y.toFixed(1) + " L" + p[0].toFixed(1) + " " + p[1].toFixed(1) +
              " L" + hx.toFixed(1) + " " + (barY - 7) + '"/>');
            if (off) out.push('<path class="closed" d="M' + (p[0] - 4).toFixed(1) + " " + (p[1] - 4).toFixed(1) + ' l8 8 m0 -8 l-8 8"/>');
            else chain.push(p);
          }
          // 35 cm tails from sensor to sensor; the gap faces the side the bus comes from (see plan)
          if (chain.length > 1) out.push('<path class="chain ' + cls + '" d="M' + chain.map(function (p) { return p[0].toFixed(1) + " " + p[1].toFixed(1); }).join(" L") + '"/>');
          for (q = 0; q < no; q++) if (h.closed.indexOf(q) < 0) out.push(dot(pos[q], rg.dot));
          // the head is opaque: the hoses running under it disappear and the outlets read clearly (owner 26.10)
          out.push('<circle class="hdisc" cx="' + cx.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' + (hr + 1).toFixed(1) + '"/>');
          out.push(head(cx, y, hr, h.outlets, h.closed, cls));
          heads.push([cx, y]);
          // the two end sensors of the chain take the bus; one big head on a figure-eight is plugged at its sides instead
          if (chain.length > 1 && !(res.branched && cls === "seed" && list.length === 1))
            ports.push({ key: key, c: [cx, y], no: no, ends: [chain[chain.length - 1], chain[0]] });
          att.push([cx, y - hr]);
        });
      }
      return att;
    }

    var seedBar = frameY + (seedGravity ? 40 : ringTop + 24);
    var sAtt = machineRow(seed, seedGravity, res.seedRows, frameY, seedBar, "seed", opt.seedSensor);
    var fertY = seedBar + 84, fertBar = fertY + (fertGravity ? 40 : Math.max.apply(null, [0].concat(fert.map(function (h) { return ring(h.outlets, fw / Math.max(1, fn)).ry; }))) + 24), fAtt = [];
    if (fn || (cfg.fert === "separate" && fertGravity)) fAtt = machineRow(fert, fertGravity, res.fertRows, fertY, fertBar, "fert", opt.fertSensor);

    // where the bus meets the seed side: heads, or the two ends of the fence
    var ends = seedGravity ? [sAtt[0], sAtt[sAtt.length - 1]] : sAtt;
    var c4 = sku.comm4, loopNote = "";

    /* trunk: one stock cable per stretch, joints where the machines couple (owner 22.10, cable_calc b813e98):
       4 m along the tractor to its hitch (below the power socket), then on A and C 11 m to the drill;
       on B 11 m through the cart to its rear hitch and 8 m drawbar on to the splitter */
    var trunk = res.network.filter(function (p) { return ["tractor", "hitch", "cart", "drawbar"].indexOf(p.where) >= 0; });
    // the trunk crosses to the first head above the bus, so it never runs on top of the 4 m cables
    var trunkY = seedGravity ? frameY - 40 : busY - 30;
    var toDrill = res.branched ? [[tx, sy - 11]]
      : [[tx, trunkY], [ends[0][0], trunkY], [ends[0][0], ends[0][1] - (seedGravity ? 7 : 0)]];
    var trunkPieces = { tractor: [[tx, 104], [tx, hitchY]], hitch: [[tx, hitchY]].concat(toDrill),
                        cart: [[tx, hitchY], [tx, cartRearY]], drawbar: [[tx, cartRearY]].concat(toDrill) };
    trunk.forEach(function (p, i) {
      var pc = trunkPieces[p.where];
      // a hub in the 11 m stretch: two 6 m halves with the hub between (owner 30.10)
      if (p.hub) pc = cut(pc, [6, 6])[p.hub === "before" ? 0 : 1];
      cable(pc, sku["comm" + p.len]);
      if (i && p.hub !== "after") out.push(hitchMark(pc[0][0], pc[0][1], true));
      // on a level stretch of cable (trailed drill) the hub turns: its leads go up and down, clear of the cable (owner 31.10)
      if (p.hub === "before") hubMark(pc[pc.length - 1][0], pc[pc.length - 1][1], Math.abs(pc[pc.length - 1][1] - pc[pc.length - 2][1]) < 0.5);
    });

    function headToHead(a, b) {
      var p = [[a[0], a[1]], [a[0], busY], [b[0], busY], [b[0], b[1]]];
      cable(p, c4);
    }
    if (!res.branched) {
      if (!seedGravity) for (var i = 0; i < n - 1; i++) headToHead(sAtt[i], sAtt[i + 1]);
      var last = ends[ends.length - 1], tKey = res.total >= 12 ? "term_esd" : "term_can";
      if (!fAtt.length) {   // with fertiliser the bus runs on and the terminator closes it there
        var tX = last[0] + (seedGravity ? 26 : Math.max(hr, ring(seed[n - 1].outlets, fw / n).rx) + 22), tY = seedGravity ? last[1] : busY;
        link(seedGravity ? [last, [tX - 9, tY]] : [[last[0], last[1]], [last[0], busY], [tX - 9, busY]]);
        term(tX, tY, tKey);
      }
    } else {
      /* Figure-eight (owner 22.10): on each side an ARM from the splitter straight to the OUTER device, the chain
         inward through every head (4 m, fertiliser heads of that side included, by their place across the drill)
         and a 2 m RETURN from the inner device into the same splitter. One ESD terminator on the sixth port. */
      var fb8 = fertY - Math.max(hr, Math.max.apply(null, [0].concat(fertGravity ? [] : fert.map(function (h) { return ring(h.outlets, fw / Math.max(1, fn)).ry; })))) - 16;
      var big = !seedGravity && n === 1;
      // one big head: the arm comes down outside its ring and plugs into the sensor at the side of the ring
      var bigRx = big ? ring(seed[0].outlets, fw).rx : 0, bigOff = big ? Math.max(hr + 48, bigRx + 16) : 0;
      /* the free vertical lanes of the seed row: between two heads, or outside the outer ones */
      var seedHeadsX = seedGravity ? [] : sAtt.map(function (q) { return q[0]; }), share = big ? 2 * (bigRx + 10) : fw / Math.max(1, n);
      var underSeed = frameY + ringTop + 10;
      function seedGap(x, sg, outer) {
        if (outer) return sg < 0 ? seedHeadsX[0] - share / 2 - 6 : seedHeadsX[seedHeadsX.length - 1] + share / 2 + 6;
        var gaps = [seedHeadsX[0] - share / 2 - 6, seedHeadsX[seedHeadsX.length - 1] + share / 2 + 6];
        for (var g = 0; g + 1 < seedHeadsX.length; g++) gaps.push((seedHeadsX[g] + seedHeadsX[g + 1]) / 2);
        // the nearest one; of two as near, the one on the loop's own side; each loop keeps 6 px to its side of the lane,
        // so the two returns sharing the middle lane never run along each other
        gaps.sort(function (a, b) { return Math.abs(a - x) - Math.abs(b - x) || ((b - x) * sg > 0) - ((a - x) * sg > 0); });
        return gaps[0] + sg * 6;
      }
      function sideDevices(side) {
        var left = side === "L", devs = [], k;
        if (seedGravity) {
          var mid = Math.ceil(sAtt.length / 2), half = left ? sAtt.slice(0, mid) : sAtt.slice(mid).reverse();
          if (half.length) devs.push({ row: "seed", gravity: true, entry: [half[0][0], half[0][1] - 7], exit: [half[half.length - 1][0], half[half.length - 1][1] - 7] });
        } else if (big) {
          var sg = left ? -1 : 1;
          devs.push({ row: "seed", big: true, entry: [tx + sg * Math.max(hr + 2, bigRx), frameY], exit: [tx + sg * 6, frameY - hr] });
        } else {
          // the loops split as the canon does (kit-rules splitRow, owner 29.10): by the sensors, whole heads
          for (k = 0; k < n; k++) if ((k < res.loops.split.seed) === left) devs.push({ row: "seed", entry: sAtt[k], exit: sAtt[k] });
        }
        if (fertGravity && fAtt.length) {
          // a gravity fertiliser row is one device of one loop: in at its outer end, out at the other
          var fe = fAtt[0], fx = fAtt[fAtt.length - 1];
          if ((res.loops.split.fert > 0) === left) devs.push({ row: "fert", gravity: true, entry: left ? [fe[0], fe[1] - 7] : [fx[0], fx[1] - 7], exit: left ? [fx[0], fx[1] - 7] : [fe[0], fe[1] - 7] });
        } else {
          for (k = 0; k < fn; k++) if ((k < res.loops.split.fert) === left) devs.push({ row: "fert", entry: fAtt[k], exit: fAtt[k] });
        }
        // outer first: the arm reaches the device farthest from the middle, the return leaves the nearest one
        devs.sort(function (a, b) { return Math.abs(b.entry[0] - tx) - Math.abs(a.entry[0] - tx); });
        return devs;
      }
      ["L", "R"].forEach(function (side) {
        var lp = res.loops[side], devs = sideDevices(side), sg = side === "L" ? -1 : 1;
        if (!devs.length) return;
        var first = devs[0], last = devs[devs.length - 1];
        /* arm: along the frame at the splitter's height, then down to the outer device */
        var arm = first.big
          ? [[tx + sg * 10, sy], [tx + sg * bigOff, sy], [tx + sg * bigOff, frameY], first.entry]   // room for the return's label
          : first.row === "fert" && seedHeadsX.length
            // a fertiliser head further out than the seed heads: down past the outer seed head, never over it
            ? [[tx + sg * 10, sy], [seedGap(first.entry[0], sg, true), sy], [seedGap(first.entry[0], sg, true), underSeed], [first.entry[0], underSeed], first.entry]
            : first.row === "fert" && first.gravity && seedGravity
              // a fertiliser box further out than the seed box: down just outside its end, then in
              ? [[tx + sg * 10, sy], [first.entry[0] + sg * 14, sy], [first.entry[0] + sg * 14, first.entry[1]], first.entry]
              : [[tx + sg * 10, sy], [first.entry[0], sy], first.entry];
        var armPieces = lp.arm.length > 1 ? cut(arm, lp.arm) : [arm];
        armPieces.forEach(function (pc, q) { cable(pc, sku["comm" + lp.arm[q]]); });
        var armX = first.big ? tx + sg * (bigOff + 8) : tx + (first.entry[0] - tx) * 0.6;
        /* spare cable (owner 23.10): the arm is drawn to scale up to the outer head, its cable is longer;
           from 1 m of slack the slack is written over the arm (the coil is gone since the tags, owner 29.10) — in print and
           the passport only: on the site "spare ≈ 5 m" read as noise (owner 31.10) */
        var armLen = lp.arm.reduce(function (t, v) { return t + v; }, 0);
        var wM = cfg.width > 0 ? cfg.width : res.seedRows * 0.25;
        var slack = first.big ? 0 : armLen - (seedGravity ? wM / 2 : (wM / 2) * (1 - 1 / Math.max(1, n)));
        if (slack >= 1 && L.plan_slack && opt.legend) {
          var sv = (Math.round(slack * 10) / 10).toFixed(1).replace(".", L.plan_dec || ".");
          out.push(txt(sg < 0 ? Math.min(armX + 45, tx - 60) : Math.max(armX - 45, tx + 60), sy - 34,
            L.plan_slack.replace("{v}", sv), "lbl dim note", sg < 0 ? "end" : "start"));
        }
        /* chain inward, 4 m each: above the seed heads, above the fertiliser heads, or across from one row to the other */
        for (var d = 0; d + 1 < devs.length; d++) {
          var a = devs[d].exit, b = devs[d + 1].entry, both = devs[d].row === devs[d + 1].row;
          // between the two rows the cable leaves a seed head from below and runs in the gap over the fertiliser heads
          var lane = both && devs[d].row === "seed" && !devs[d].gravity ? busY : fb8;
          if (devs[d].row === "seed" && !devs[d].gravity && !both) a = [a[0], frameY + hr];
          if (devs[d + 1].row === "seed" && !devs[d + 1].gravity && !both) b = [b[0], frameY + hr];
          cable([a, [a[0], lane], [b[0], lane], b], c4);
        }
        /* return: 2 m from the inner device into the bottom of the splitter */
        // each return enters the splitter on its own side: two drops near the middle (a centre head, the inner sensors
        // of a gravity row) stay two lines, not one on top of the other
        var e = last.exit, rx = e[0] - sg * 6, rY = sy + 22, inX = tx + sg * 6;
        if (sg * (rx - tx) < 6) rx = inX;
        var ret = Math.abs(rx - inX) < 1 ? [[rx, e[1]], [rx, sy + 10]] : [[rx, e[1]], [rx, rY], [inX, rY], [inX, sy + 10]];
        // a fertiliser box on one loop is left at its far end: out beside that end and up (owner 29.10)
        if (last.row === "fert" && last.gravity) {
          var es = e[0] < tx ? -1 : 1;
          ret = [[e[0], e[1]], [e[0] + es * 14, e[1]], [e[0] + es * 14, rY], [inX, rY], [inX, sy + 10]];
        }
        // from a fertiliser head the return climbs between two seed heads, not across one (owner 29.10)
        else if (last.row === "fert" && seedHeadsX.length) {
          var ch = seedGap(e[0], sg, false);
          ret = [[e[0], e[1]], [e[0], underSeed], [ch, underSeed], [ch, rY], [inX, rY], [inX, sy + 10]];
        }
        cable(ret, sku.comm2);
      });
      if (res.network.some(function (q) { return q.where === "tail"; })) {
        /* cart behind with a hub (owner 30.10): from the sixth port 6 m down the middle of the drill to its rear hitch,
           8 m along the cart to the hub between the tanks; the terminator closes the bus on the hub */
        var tBot = (fAtt.length ? fertBar : seedBar) + 6, lane = fx0 + fw + 16;   // right of every head, inside the frame
        cable([[tx + 11, sy - 8], [tx + 30, sy - 8], [tx + 30, sy - 30], [lane, sy - 30], [lane, tBot + 4], [tx, tBot + 4], [tx, tBot + 20]], sku.comm6);
        out.push(hitchMark(tx, tBot + 20, true));
        tailHitch = true;
        var hubY = tBot + 34 + CART.db + 158;   // the middle of the cart, as on the tow-between one (owner 31.10)
        cable([[tx, tBot + 20], [tx, hubY - 10]], sku.comm8);
        hubMark(tx, hubY);
        var hx2 = tx + (res.sensors.hubs - 1) * 74;
        link([[hx2 + 15, hubY], [hx2 + 50, hubY]]);
        term(hx2 + 59, hubY, "term_esd");
      } else {
        // sixth port: the one ESD terminator of the bus, with its earth
        link([[tx + 8, sy - 8], [tx + 26, sy - 30]]);
        term(tx + 35, sy - 34, "term_esd");
      }
      out.push('<g class="splitter" data-sku="' + sku.splitter + '"><rect x="' + (tx - 11) + '" y="' + (sy - 11) + '" width="22" height="22" rx="2"/></g>');
      out.push(txt(tx - 16, sy - 14, "X1", "lbl des", "end"));
      if (L.plan_loop) loopNote = L.plan_loop;
    }

    /* fertiliser on the same bus (single line). A chain has two ends only, so nothing branches off a head (owner 29.10):
       the bus runs on from the last seed device down the right side into the right-hand fertiliser head (4 m), through
       the fertiliser heads to the left (4 m each), and the terminator closes it after the left-hand one. */
    if (!res.branched && fAtt.length) {
      var sL = ends[ends.length - 1], fL = fAtt[fAtt.length - 1], gx = fx0 + fw + 12, sY = seedGravity ? sL[1] : frameY;
      cable([[sL[0] + (seedGravity ? 0 : hr), sY], [gx, sY], [gx, fL[1]], [fL[0] + (fertGravity ? 6 : 0), fL[1]]], c4);
      var fb = fertY - hr - 16;
      if (!fertGravity) for (var f = fn - 1; f > 0; f--) cable([[fAtt[f][0], fAtt[f][1]], [fAtt[f][0], fb], [fAtt[f - 1][0], fb], [fAtt[f - 1][0], fAtt[f - 1][1]]], c4);
      var fE = fAtt[0], ftX = fE[0] - (fertGravity ? 26 : Math.max(hr, ring(fert[0].outlets, fw / fn).rx) + 22), ftY = fertGravity ? fE[1] : fb;
      link(fertGravity ? [fE, [ftX + 9, ftY]] : [[fE[0], fE[1]], [fE[0], fb], [ftX + 9, fb]]);
      term(ftX, ftY, tKey);
    }

    /* Each cable reaching a head plugs into one of the two end sensors of its chain. Pass 1 only learns from where the
       cables come and turns the gap there; pass 2 moves the cable ends onto the sensors. */
    // a cable end moved onto a sensor: its last leg follows; a single straight run gets a step halfway
    function plug(src, i, to) {
      var pts = src.slice(), old = pts[i], j = i ? i - 1 : 1;
      if (pts.length === 2) {
        var o = pts[1 - i], mid = (o[1] + to[1]) / 2;
        if (Math.abs(o[0] - to[0]) > 0.5) { var bend = [[o[0], mid], [to[0], mid]]; if (i === 0) bend.reverse(); pts.splice(1, 0, bend[0], bend[1]); }
        pts[i ? pts.length - 1 : 0] = [to[0], to[1]];
        return pts;
      }
      if (Math.abs(pts[j][0] - old[0]) < 0.5) pts[j] = [to[0], pts[j][1]];
      else if (Math.abs(pts[j][1] - old[1]) < 0.5) pts[j] = [pts[j][0], to[1]];
      pts[i] = [to[0], to[1]];
      return pts;
    }
    /* how tangled the cables are: running along each other counts ten, a crossing one (the same rules as the sweep) */
    function segsOf(pts) { var r = []; for (var i = 0; i < pts.length - 1; i++) r.push([pts[i], pts[i + 1]]); return r; }
    function vert(g) { return Math.abs(g[0][0] - g[1][0]) < 0.5; }
    function horiz(g) { return Math.abs(g[0][1] - g[1][1]) < 0.5; }
    function overlap(a0, a1, b0, b1) { return Math.min(Math.max(a0, a1), Math.max(b0, b1)) - Math.max(Math.min(a0, a1), Math.min(b0, b1)); }
    function alongs(a, b) {
      if (vert(a) && vert(b) && Math.abs(a[0][0] - b[0][0]) < 4) return overlap(a[0][1], a[1][1], b[0][1], b[1][1]) > 2;
      if (horiz(a) && horiz(b) && Math.abs(a[0][1] - b[0][1]) < 4) return overlap(a[0][0], a[1][0], b[0][0], b[1][0]) > 2;
      return false;
    }
    function crosses(a, b) {
      var v = vert(a) ? a : vert(b) ? b : null, h = v === a ? b : a;
      if (!v || !horiz(h)) return false;
      var x = v[0][0], y = h[0][1];
      return x > Math.min(h[0][0], h[1][0]) + 1 && x < Math.max(h[0][0], h[1][0]) - 1 && y > Math.min(v[0][1], v[1][1]) + 1 && y < Math.max(v[0][1], v[1][1]) - 1;
    }
    function tangles() {
      var all = wires.map(function (w) { return segsOf(w.pts); }), sc = 0;
      for (var a = 0; a < all.length; a++) for (var b = a + 1; b < all.length; b++)
        all[a].forEach(function (ga) { all[b].forEach(function (gb) { sc += alongs(ga, gb) ? 10 : crosses(ga, gb) ? 1 : 0; }); });
      return sc;
    }
    function near(e, c) { return Math.abs(e[0] - c[0]) <= hr + 1.5 && Math.abs(e[1] - c[1]) <= hr + 1.5; }
    ports.forEach(function (pt) {
      var ends = [], sum = [0, 0];
      wires.concat(links).forEach(function (w) {
        [0, w.pts.length - 1].forEach(function (i) {
          if (!near(w.pts[i], pt.c)) return;
          // the side it comes from: the first point of the cable well away from the head
          var step = i ? -1 : 1, j = i, far = w.pts[w.pts.length - 1 - i];
          for (; j >= 0 && j < w.pts.length; j += step) if (Math.hypot(w.pts[j][0] - pt.c[0], w.pts[j][1] - pt.c[1]) > hr + 40) { far = w.pts[j]; break; }
          var v = [far[0] - pt.c[0], far[1] - pt.c[1]], d = Math.hypot(v[0], v[1]) || 1;
          sum[0] += v[0] / d; sum[1] += v[1] / d;
          ends.push({ w: w, i: i, far: far });
        });
      });
      if (!ends.length) return;
      if (pass1) {
        // cables from above and below at once: the gap goes to the outer side of the head
        // (or, at a head in the middle, the side its cables lean to)
        var th = Math.hypot(sum[0], sum[1]) >= 0.5 ? Math.atan2(sum[1], sum[0]) : Math.abs(sum[0]) > 0.05 ? (sum[0] < 0 ? Math.PI : 0) : pt.c[0] < tx ? Math.PI : 0;
        GAP[pt.key] = ((Math.round((th + Math.PI / 2) * pt.no / (2 * Math.PI) + 0.5) % pt.no) + pt.no) % pt.no;
        return;
      }
      // which cable takes which end sensor: the way with fewer cables crossing or running along each other (owner 29.10);
      // even: in the order the cables go, seen across the gap
      var gth = -Math.PI / 2 + (2 * Math.PI * ((GAP[pt.key] || 0) - 0.5)) / pt.no, ux = -Math.sin(gth), uy = Math.cos(gth);
      function lat(q) { return (q[0] - pt.c[0]) * ux + (q[1] - pt.c[1]) * uy; }
      ends.forEach(function (e) { e.key = lat(e.w.pts[e.w.pts.length - 1 - e.i]) * 1000 + lat(e.far); });
      ends.sort(function (a, b) { return a.key - b.key; });
      var pe = pt.ends.slice().sort(function (a, b) { return lat(a) - lat(b); });
      var orders = ends.length === 2 ? [[pe[0], pe[1]], [pe[1], pe[0]]] : [ends.map(function (e, k) { return pe[Math.min(k, 1)]; })];
      var best = null;
      orders.forEach(function (ord) {
        var keep = ends.map(function (e) { return e.w.pts.slice(); });
        ends.forEach(function (e, k) { e.w.pts = plug(e.w.pts, e.i, ord[k]); });
        var sc = tangles() + 20 * ends.filter(function (e) { return overAHead(e.w.pts); }).length;   // and never over a head
        if (!best || sc < best.sc) best = { sc: sc, pts: ends.map(function (e) { return e.w.pts; }) };
        ends.forEach(function (e, k) { e.w.pts = keep[k]; });
      });
      ends.forEach(function (e, k) { e.w.pts = best.pts[k]; });
    });
    if (pass1) return null;

    /* Untangle (owner 29.10): a cable may not run along another, and crossings are kept down. An inner leg of a cable
       (never one that ends in a sensor) steps aside by 8-48 px while that leaves fewer tangles; its neighbouring legs
       keep their direction and nothing is moved over a head. */
    function tanglesOf(w) {
      var mine = segsOf(w.pts), sc = 0;
      wires.forEach(function (o) {
        if (o === w) return;
        segsOf(o.pts).forEach(function (gb) { mine.forEach(function (ga) { sc += alongs(ga, gb) ? 10 : crosses(ga, gb) ? 1 : 0; }); });
      });
      return sc;
    }
    function overAHead(pts) {
      return segsOf(pts).some(function (g) {
        return heads.some(function (c) {
          var vx = g[1][0] - g[0][0], vy = g[1][1] - g[0][1], l2 = vx * vx + vy * vy || 1;
          var t = Math.max(0, Math.min(1, ((c[0] - g[0][0]) * vx + (c[1] - g[0][1]) * vy) / l2));
          return Math.hypot(g[0][0] + t * vx - c[0], g[0][1] + t * vy - c[1]) < hr;
        });
      });
    }
    function keepsWay(a, b, nb) {
      var d0 = [b[0] - a[0], b[1] - a[1]], d1 = [nb[0] - a[0], nb[1] - a[1]];
      return d0[0] * d1[0] + d0[1] * d1[1] > 0 && Math.hypot(d1[0], d1[1]) >= 6;
    }
    for (var round = 0; round < 8; round++) {
      var move = null;
      wires.forEach(function (w) {
        var now = tanglesOf(w);
        if (!now) return;
        for (var i = 1; i + 2 < w.pts.length; i++) {
          var up = vert([w.pts[i], w.pts[i + 1]]);
          // fixed steps, and the steps that clear another cable's leg exactly
          var steps = [8, -8, 16, -16, 24, -24, 32, -32, 40, -40, 48, -48], at = up ? 0 : 1, here = w.pts[i][at];
          wires.forEach(function (o) { if (o !== w) o.pts.forEach(function (q) { [q[at] - 8 - here, q[at] + 8 - here].forEach(function (d) { if (Math.abs(d) <= 120) steps.push(d); }); }); });
          steps.forEach(function (d) {
            var np = w.pts.slice();
            np[i] = up ? [np[i][0] + d, np[i][1]] : [np[i][0], np[i][1] + d];
            np[i + 1] = up ? [np[i + 1][0] + d, np[i + 1][1]] : [np[i + 1][0], np[i + 1][1] + d];
            if (!keepsWay(w.pts[i - 1], w.pts[i], np[i]) || !keepsWay(w.pts[i + 2], w.pts[i + 1], np[i + 1]) || overAHead(np)) return;
            var keep = w.pts; w.pts = np; var gain = now - tanglesOf(w); w.pts = keep;
            if (gain > 0 && (!move || gain > move.gain)) move = { w: w, pts: np, gain: gain };
          });
        }
      });
      if (!move) break;
      move.w.pts = move.pts;
    }

    /* numbers: W1 the power cable, then the bus in the order it was laid; the tag carries number and length */
    var LEN = {}, tags = [], WN = 2;
    // tags keep off the hubs: the box with its leads and its A2 label
    hubsAt.forEach(function (h) { tags.push([h[0] - h[3] / 2, h[1] - h[2] / 2 - 2, h[3], h[2] + 4], [h[0] + h[3] / 2 - 25, h[1] - h[2] / 2 - 17, 24, 15]); });
    [2, 4, 6, 8, 11].forEach(function (l) { LEN[sku["comm" + l]] = l; });
    function tagAt(x, y, lines, skuOf) {
      var w = 8 + Math.max.apply(null, lines.map(function (t) { return t.length; })) * 7.6, h = 6 + lines.length * 13;
      return { box: [x - w / 2, y - h / 2, w, h], svg: '<g class="wtag"' + (skuOf ? ' data-sku="' + skuOf + '"' : "") + '><rect x="' + (x - w / 2).toFixed(1) + '" y="' + (y - h / 2).toFixed(1) +
        '" width="' + w.toFixed(1) + '" height="' + h + '" rx="4"/>' + lines.map(function (t, i) { return txt(x, y - h / 2 + 13 + i * 13, t, "wtag-t"); }).join("") + "</g>" };
    }
    function free(b) {
      return !tags.some(function (o) { return b[0] < o[0] + o[2] + 3 && o[0] < b[0] + b[2] + 3 && b[1] < o[1] + o[3] + 3 && o[1] < b[1] + b[3] + 3; });
    }
    var t1 = tagAt(tx + 28, 102, ["W1"], sku.power);
    tags.push(t1.box); out.push(t1.svg);
    wires.forEach(function (w) {
      w.name = "W" + WN++;
      var segs = [];
      for (var i = 0; i < w.pts.length - 1; i++) segs.push([w.pts[i], w.pts[i + 1], Math.hypot(w.pts[i + 1][0] - w.pts[i][0], w.pts[i + 1][1] - w.pts[i][1])]);
      segs.sort(function (a, b) { return b[2] - a[2]; });
      // the longest leg first, its middle first; the first spot clear of the other tags wins
      var pick = null;
      segs.some(function (sg) {
        var vert = Math.abs(sg[0][0] - sg[1][0]) < 0.5, lines = vert ? [w.name, LEN[w.sku] + "m"] : [w.name + "\u00b7" + LEN[w.sku] + "m"];
        // on the cable; where two cables run close together, beside it
        return [[0.5, 0], [0.3, 0], [0.7, 0], [0.15, 0], [0.85, 0], [0.5, -1], [0.5, 1], [0.3, -1], [0.3, 1], [0.7, -1], [0.7, 1], [0.5, -2.5], [0.5, 2.5], [0.5, -3.6], [0.5, 3.6], [0.3, -3.6], [0.7, 3.6]].some(function (c) {
          var x = sg[0][0] + (sg[1][0] - sg[0][0]) * c[0], y = sg[0][1] + (sg[1][1] - sg[0][1]) * c[0], t = tagAt(x, y, lines, w.sku);
          if (c[1]) t = vert ? tagAt(x + c[1] * (t.box[2] / 2 + 4), y, lines, w.sku) : tagAt(x, y + c[1] * (t.box[3] / 2 + 4), lines, w.sku);
          if (!pick) pick = t;
          if (free(t.box)) { pick = t; return true; }
        });
      });
      tags.push(pick.box); out.push(pick.svg);
    });
    // connection points: wherever a cable or the terminator's link plugs in, except at a coupling or into the splitter
    var cpts = {};
    wires.concat(links).forEach(function (w) {
      [w.pts[0], w.pts[w.pts.length - 1]].forEach(function (e) {
        var k = e[0].toFixed(0) + "," + e[1].toFixed(0);
        if (cpts[k] || hitches.some(function (h) { return Math.abs(h[0] - e[0]) < 3 && Math.abs(h[1] - e[1]) < 3; }) ||
          hubsAt.some(function (h) { return Math.abs(h[0] - e[0]) < 18 && Math.abs(h[1] - e[1]) < h[2] / 2 + 4; }) ||
          (res.branched && Math.abs(e[0] - tx) < 16 && Math.abs(e[1] - sy) < 16)) return;
        cpts[k] = 1;
        out.push('<circle class="cpt" cx="' + e[0].toFixed(1) + '" cy="' + e[1].toFixed(1) + '" r="6.5"/>');
      });
    });

    /* the machines under everything else */
    var bg = [], dBot = (fAtt.length ? fertBar : seedBar) + 6, Rx = fx0 + fw + 26, bottom;
    // the terminator stays inside the frame, on either side
    out.forEach(function (o) { var m = /class="term"[^>]*>(?:<title>[^<]*<\/title>)?<rect x="([\d.]+)"/.exec(o); if (m) Rx = Math.max(Rx, +m[1] + 32, 2 * tx - (+m[1] - 14)); });
    var Lx = 2 * tx - Rx;
    bg.push('<path class="beam" d="M' + tx + " 144 L" + tx + " " + (hitchY - 14) + '"/>');            // the tractor's own hitch
    bg.push('<rect class="frame" x="' + Lx + '" y="' + dTop + '" width="' + (Rx - Lx) + '" height="' + (dBot - dTop) + '" rx="6"/>');
    // a mounted drill hangs on the three-point linkage; a trailed one runs on wheels at the sides of its frame
    bg.push(cfg.machine === "mounted" ? beams(dTip, dTop, 22, 70) : beams(dTip, dTop, 5, Math.min(150, (Rx - Lx) * 0.17)));
    if (cfg.machine !== "mounted") [Lx, Rx].forEach(function (x) {
      // the cart's wheel size, on the frame's edge: wide drills fill the sheet (owner 29.10: the wheel looked too small)
      var wh = Math.min(64, dBot - dTop - 12);
      bg.push('<rect class="wheel" x="' + (x - 9) + '" y="' + ((dTop + dBot) / 2 - wh / 2) + '" width="18" height="' + wh + '" rx="5"/>'); });
    bg.push(txt(Lx, dTop - 10, L.plan_drill, "lbl dim", "start"));
    function cart(tip) {
      // three tanks in a row, wheels at the back
      var b = tip + CART.db, hw = CART.hw, len = CART.len;
      bg.push(beams(tip, b, 5, hw - 12));
      bg.push('<rect class="frame" x="' + (tx - hw) + '" y="' + b + '" width="' + 2 * hw + '" height="' + len + '" rx="10"/>');
      [12, 112, 212].forEach(function (t) {
        bg.push('<rect class="tank" x="' + (tx - hw + 14) + '" y="' + (b + t) + '" width="' + (2 * hw - 28) + '" height="92" rx="12"/>'); });
      [-1, 1].forEach(function (sg) {
        bg.push('<rect class="wheel" x="' + (sg < 0 ? tx - hw - 22 : tx + hw + 4) + '" y="' + (b + len - 110) + '" width="18" height="64" rx="5"/>'); });
      bg.push(txt(tx + hw + 32, b + 24, L.plan_cart, "lbl dim", "start"));
      return b + len;
    }
    if (layout === "B") cart(hitchY + 14);
    if (layout === "C") {
      // the drill's rear hitch to the cart: no cable crosses it yet
      bg.push('<path class="beam" d="M' + tx + " " + dBot + " L" + tx + " " + (dBot + 6) + '"/>');
      if (!tailHitch) out.push(hitchMark(tx, dBot + 20, false));   // with a hub on the cart the bus crosses it (drawn with the tail)
      bottom = cart(dBot + 34) + 30;
    } else bottom = dBot + 30;
    out.unshift.apply(out, bg);
    if (loopNote) { out.push(txt(W / 2, bottom + 4, loopNote, "lbl dim note")); bottom += 30; }
    // width dimension in the manner of a tramline screen: arrow over the full frame
    var dimY = bottom + 6;
    out.push('<path class="dimline" d="M' + fx0 + " " + (dimY - 10) + " L" + fx0 + " " + (dimY + 10) + " M" + fx0 + " " + dimY + " L" + (fx0 + fw) + " " + dimY +
      " M" + (fx0 + fw) + " " + (dimY - 10) + " L" + (fx0 + fw) + " " + (dimY + 10) + '"/>');
    out.push('<rect class="dim-bg" x="' + (W / 2 - 170) + '" y="' + (dimY - 18) + '" width="340" height="36"/>');
    out.push(txt(W / 2, dimY + 9, opt.dimLabel, "dim-t"));

    /* designations per article (the site writes them into its parts list, owner 29.10) and, for print and the
       passport only (opt.legend), a legend under the drawing: designation, name, article; the same cables on one line
       ("W5–W7, W10"), wrapped */
    var DISP = { "AC01.01.03.02.000": "n_mini", "AC01.01.04.03.000": "n_h5", "AC01.01.04.04.100": "n_one" };
    var rows = [[["A1"], L[DISP[sku.display]], sku.display], [["W1"], L.n_power, sku.power]], bySku = {};
    wires.forEach(function (w) {
      if (!bySku[w.sku]) { bySku[w.sku] = []; rows.push([bySku[w.sku], L.n_comm.replace("{l}", LEN[w.sku]), w.sku]); }
      bySku[w.sku].push(+w.name.slice(1));
    });
    rows.forEach(function (r) {
      if (typeof r[0][0] !== "number") return;
      var nums = r[0], parts = [], i = 0, lines = [""];
      while (i < nums.length) {
        var j = i; while (j + 1 < nums.length && nums[j + 1] === nums[j] + 1) j++;
        parts.push(j - i >= 2 ? "W" + nums[i] + "\u2013W" + nums[j] : nums.slice(i, j + 1).map(function (v) { return "W" + v; }).join(", "));
        i = j + 1;
      }
      parts.join(", ").split(", ").forEach(function (t) {
        var l = lines[lines.length - 1];
        if (l && (l + ", " + t).length > 14) lines.push(t); else lines[lines.length - 1] = l ? l + ", " + t : t;
      });
      r[0] = lines;
    });
    if (res.branched) rows.push([["X1"], L.n_splitter, sku.splitter]);
    if (hubsAt.length) rows.push([hubsAt.map(function (h, i) { return "A" + (i + 2); }), L.n_hub8 || "HUB-8", sku.hub8]);
    var tk = res.network.filter(function (q) { return /^term_/.test(q.key); })[0];
    if (tk) rows.push([["X9"], L[tk.key === "term_esd" ? "n_termEsd" : "n_termCan"], sku[tk.key]]);
    hitches.forEach(function (h) { rows.push([[h[2]], L.plan_hitch, ""]); });
    var sN = res.seedRows, fN = fAtt.length ? res.fertRows : 0;
    // one article for seed and fertiliser sensors: one line, B1 to the last
    if (fN && opt.fertSensor === opt.seedSensor) { sN += fN; fN = 0; }
    rows.push([["B1\u2013B" + sN], L.n_sensor.replace("{d}", cfg.seedTube) + "  \u00d7" + sN, opt.seedSensor]);
    if (fN) rows.push([["B" + (sN + 1) + "\u2013B" + (sN + fN)], L.n_sensor.replace("{d}", cfg.fertTube === "same" ? cfg.seedTube : cfg.fertTube) + "  \u00d7" + fN, opt.fertSensor]);
    var des = {};
    rows.forEach(function (r) { if (r[2]) des[r[2]] = (des[r[2]] ? des[r[2]] + ", " : "") + r[0].join(", "); });
    var ly = dimY + 70;
    if (opt.legend) out.push('<path class="legrule" d="M30 ' + (ly - 30) + ' L970 ' + (ly - 30) + '"/>');
    if (opt.legend) rows.forEach(function (r) {
      var hl = r[2] ? ' data-hl="' + r[2] + '"' : "";
      out.push('<g class="legrow"' + hl + ">" + r[0].map(function (k, q) { return txt(120, ly + q * 21, k + (q < r[0].length - 1 ? "," : ""), "lbl leg-k", "start"); }).join("") +
        txt(290, ly, r[1] || "", "lbl leg-n", "start") + txt(870, ly, r[2] || "\u2014", "lbl leg-a", "end") + "</g>");
      ly += 27 + (r[0].length - 1) * 21;
    });
    if (opt.legend) dimY = ly - 24;
    if (opt.legend && hubsAt.length) { var hb = hubBody(res.sensors, L, 120, dimY + 20, true); out.push(hb.svg); dimY += 20 + hb.h; }

    return {
      svg: '<svg id="plan-svg" viewBox="0 0 ' + W + " " + (dimY + 34) + '" role="img" aria-label="' + esc(opt.aria) + '">' +
        out.map(function (o) { return typeof o === "string" ? o : path(o.pts, o.cls, o.sku); }).join("") + "</svg>",
      // cables in the kit that have no place on the drawing (none since the figure-eight; kept as a guard)
      spare: res.network.filter(function (p) { return p.len; }).length - drawnCables,
      des: des
    };
  }

  /* Two passes over the same drawing (owner 29.10): the first only learns from which side the cables reach each head,
     the second turns each ring's gap there, so the bus plugs into the two end sensors of the chain. */
  function plan(cfg, res, opt) {
    var gaps = {};
    build(cfg, res, opt, gaps, true);
    return build(cfg, res, opt, gaps, false);
  }

  /* One sign per kind of 3-pin sensor (owner 31.10), the same on the drawing, in the connection diagram and in the parts list:
     shaft = a hexagon (the shaft), hopper = a tank, fan = a rotor, ground speed = a wheel. */
  function kindGlyph(kind, x, y, r) {
    var f = function (v) { return (+v).toFixed(1); };
    if (kind === "shaft") {
      var pts = []; for (var i = 0; i < 6; i++) pts.push(f(x + r * Math.cos(Math.PI / 3 * i)) + "," + f(y + r * Math.sin(Math.PI / 3 * i)));
      return '<polygon class="kg" points="' + pts.join(" ") + '"/>';
    }
    if (kind === "hopper") return '<path class="kg" d="M' + f(x - r) + " " + f(y - r) + " L" + f(x + r) + " " + f(y - r) + " L" + f(x + r * 0.45) + " " + f(y + r) + " L" + f(x - r * 0.45) + " " + f(y + r) + ' Z"/>';
    if (kind === "turbine") return '<circle class="kg" cx="' + f(x) + '" cy="' + f(y) + '" r="' + f(r) + '"/><path class="kg" d="M' + f(x) + " " + f(y - r) + " L" + f(x) + " " + f(y + r) + " M" + f(x - r) + " " + f(y) + " L" + f(x + r) + " " + f(y) + '"/>';
    return '<circle class="kg" cx="' + f(x) + '" cy="' + f(y) + '" r="' + f(r) + '"/><circle class="kgd" cx="' + f(x) + '" cy="' + f(y) + '" r="' + f(r * 0.35) + '"/>';
  }
  function kindIcon(kind) {
    if (kind === "hub") return '<svg class="kicon" viewBox="0 0 16 16" aria-hidden="true"><rect class="kg" x="3" y="2.5" width="10" height="11" rx="1.5"/></svg>'; return '<svg class="kicon" viewBox="0 0 16 16" aria-hidden="true">' + kindGlyph(kind, 8, 8, 5.5) + "</svg>"; }

  /* The HUB-8 connection diagram (owner 31.10, A): every port with its whole chain — the lead, the extension and its length,
     the sensor's sign and name, what comes with it (bracket, star wheel). An unused lead takes a 3-pin blind plug, an unused
     6-pin port a blind plug of its own. On the site it opens on a tap; in print and the passport it stands under the legend. */
  function hubBody(sensors, L, ox, oy, print) {
    var nameCls = print ? "lbl leg-n" : "lbl", numCls = print ? "lbl leg-k" : "lbl des";   // in print: the legend's type
    var o = [], esc2 = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
    var T = function (x, y, t, cls, a) { return '<text x="' + x + '" y="' + y + '" class="' + cls + '" text-anchor="' + (a || "start") + '">' + esc2(t) + "</text>"; };
    var acc = function (kind) {
      var k = sensors.kinds[kind] || {}, a = [];
      if (k.bracket) a.push(L.acc_bracket || "angle bracket");
      if (k.star) a.push((L.acc_star || "star wheel {d}").replace("{d}", L["x_" + k.star] || k.star));
      return a.join(" \u00b7 ");
    };
    var y = oy;
    for (var h = 0; h < sensors.hubs; h++) {
      var mine = sensors.ports.filter(function (q) { return q.hub === h + 1; });
      o.push(T(ox, y + 16, "A" + (h + 2) + " \u00b7 HUB-8", "lbl des"));
      var top = y + 30, rowH = 34, bx = ox, bw = 84, bh = 8 * rowH + 18;
      o.push('<g class="hub8 big"><rect x="' + bx + '" y="' + top + '" width="' + bw + '" height="' + bh + '" rx="6"/></g>');
      o.push(T(bx + bw / 2, top + bh / 2 + 5, "HUB-8", "lbl", "middle"));
      for (var hn = 0; hn < 2; hn++) {
        var used = mine.some(function (q) { return q.port > hn * 4 && q.port <= hn * 4 + 4; });
        var gy = top + 9 + hn * 4 * rowH + (hn ? 8 : 0);
        o.push('<path class="bracket" d="M' + (bx + bw + 6) + " " + (gy + 2) + " L" + (bx + bw + 12) + " " + (gy + 2) + " L" + (bx + bw + 12) + " " + (gy + 4 * rowH - 6) + " L" + (bx + bw + 6) + " " + (gy + 4 * rowH - 6) + '"/>');
        if (!used) { o.push(T(bx + bw + 24, gy + 2 * rowH + 2, L.port_free6 || "free · blind plug", nameCls + " dim")); continue; }
        for (var i = 0; i < 4; i++) {
          var n = hn * 4 + i + 1, q = mine.filter(function (x) { return x.port === n; })[0], py = gy + i * rowH + 14;
          o.push(T(bx + bw + 20, py + 5, String(n), numCls));
          if (!q) {
            o.push('<path class="lead free" d="M' + (bx + bw + 34) + " " + py + " L" + (bx + bw + 60) + " " + py + '"/>');
            o.push(T(bx + bw + 68, py + 5, L.port_free || "free · 3-pin plug", nameCls + " dim"));
            continue;
          }
          var ext = (sensors.kinds[q.kind] || {}).ext || [], ex = bx + bw + 34, gx = ex + 72;
          o.push('<g class="hubport big"><path class="lead" d="M' + ex + " " + py + " L" + (gx - 9) + " " + py + '"/>' + kindGlyph(q.kind, gx, py, 7) + "</g>");
          if (ext.length) o.push(T((ex + gx - 9) / 2, py - 5, ext.join(" + ") + " m", "lbl dim small", "middle"));
          o.push(T(gx + 14, py + (acc(q.kind) ? 0 : 5), L["port_" + q.kind] || q.kind, nameCls));
          if (acc(q.kind)) o.push(T(gx + 14, py + 15, "+ " + acc(q.kind), nameCls + " dim small"));
        }
      }
      y = top + bh + 24;
    }
    return { svg: o.join(""), h: y - oy };
  }
  function hubDetail(sensors, L) {
    var b = hubBody(sensors, L, 12, 4);
    return '<svg id="hub-svg" viewBox="0 0 530 ' + (b.h + 8) + '" role="img" aria-label="HUB-8">' + b.svg + "</svg>";
  }
  root.WizardDraw = { silhouette: silhouette, head: head, headEditor: headEditor, plan: plan, hubDetail: hubDetail, kindIcon: kindIcon };
})(this);
